module.exports = __webpack_public_path__ + "img/13.8.TSS.29a17e38.png";